import { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { trackPage } from '../app/ga'

class Analytics extends Component {
  componentDidMount() {
    trackPage(getPage(this.props))
  }

  componentWillReceiveProps(nextProps) {
    const nextPage = getPage(nextProps)
    if (nextPage !== getPage(this.props)) {
      trackPage(nextPage)
    }
  }

  render() {
    return null
  }
}
function getPage(props) {
  return props.location.pathname + props.location.search
}

export default withRouter(Analytics)



// WEBPACK FOOTER //
// ./src/components/Analytics.js